import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { SessionPrepInfo } from 'features/sessions/config/types';

export const useNextSessionQuery = (coachingSessionId: string | undefined) => {
  const { request } = useQueryHTTPRequest();

  return useQuery<SessionPrepInfo>(
    [queryKeys.coachingSessionPrepInfo, coachingSessionId],
    () =>
      request({
        url: `/api/coach/coaching-sessions/${coachingSessionId}/prep-info`,
      }),
    {
      enabled: !!coachingSessionId,
      useErrorBoundary: false,
      retry: 1,
    }
  );
};
